import React, { useEffect, useState, useCallback } from 'react';
import './Formaciones.css';
import { Link } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';

const AULA_URL = 'https://centrocomunicar.com/virtual/login/index.php';
const API_BASE = 'https://centrocomunicar.com/api-comunicar/endpoints/courses.php';

/* ════════════════════════════════════════
   LOGO
════════════════════════════════════════ */
const LogoComunicar = ({ height = 40 }) => (
  <img
    src="/images/logo_centro.png"
    alt="Comunicar"
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

/* ════════════════════════════════════════
   ICONS
════════════════════════════════════════ */
const IconPlay        = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M10 8l6 4-6 4V8z" fill="currentColor"/></svg>);
const IconLive        = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="12" cy="12" r="3" fill="currentColor"/><path d="M8.5 8.5a5 5 0 000 7M15.5 8.5a5 5 0 010 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUsers       = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconArrow       = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCalendar    = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><rect x="3" y="4" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="2"/><path d="M3 9h18M8 2v4M16 2v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconExternalLink= () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M15 3h6v6M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconRefresh     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconMonitor     = () => (<svg viewBox="0 0 24 24" fill="none" width="22" height="22"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M8 21h8M12 17v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBook        = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCertificate = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="12" cy="8" r="6" stroke="currentColor" strokeWidth="2"/><path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevLeft    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevRight   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCartPlus    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBag         = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCart      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

/* ════════════════════════════════════════
   HELPERS
════════════════════════════════════════ */
const FG_TIPO_ICON  = { video:'🎥', pdf:'📄', clase:'🎓', webinar:'📡', recurso:'📦' };
const FG_CAT_COLORS = { Lenguaje:'verde', TEA:'azul', Habla:'amarillo', Aprendizaje:'morado', Familia:'rosa', General:'gris' };
const FG_COLOR_MAP  = {
  verde:    'linear-gradient(135deg,#c8e8de,#8BCAAF)',
  azul:     'linear-gradient(135deg,#dbeafe,#60a5fa)',
  amarillo: 'linear-gradient(135deg,#fef9c3,#fbbf24)',
  morado:   'linear-gradient(135deg,#ede9fe,#a78bfa)',
  rosa:     'linear-gradient(135deg,#fce7f3,#f9a8d4)',
  gris:     'linear-gradient(135deg,#f3f8f5,#8BCAAF)',
};

const catColorMap = { lenguaje:'lenguaje', habla:'habla', tea:'tea', aprendizaje:'aprendizaje', tartamudez:'tartamudez' };

function getCatClass(nombre) {
  if (!nombre) return 'lenguaje';
  return catColorMap[nombre.toLowerCase().replace(/\s/g,'')] || 'lenguaje';
}

function detectTipo(curso) {
  const txt = (curso.fullname + ' ' + (curso.shortname||'')).toLowerCase();
  if (txt.includes('vivo')||txt.includes('live')||txt.includes('taller')||txt.includes('webinar')) return 'vivo';
  return 'grabado';
}

function detectCategoria(curso) {
  if (curso.categoria) return curso.categoria;
  const txt = (curso.fullname||'').toLowerCase();
  if (txt.includes('lenguaje')) return 'Lenguaje';
  if (txt.includes('habla')||txt.includes('fonol')||txt.includes('tartam')) return 'Habla';
  if (txt.includes('tea')||txt.includes('autis')) return 'TEA';
  if (txt.includes('aprendizaje')||txt.includes('dislexia')) return 'Aprendizaje';
  return 'Lenguaje';
}

/* ════════════════════════════════════════
   SKELETON
════════════════════════════════════════ */
const SkeletonCard = () => (
  <div className="curso-card curso-card--skeleton">
    <div className="skel skel--thumb"/>
    <div className="curso-card__body">
      <div className="skel skel--line skel--short"/>
      <div className="skel skel--line skel--long"/>
      <div className="skel skel--line skel--mid"/>
    </div>
    <div className="curso-card__footer">
      <div className="skel skel--line skel--short"/>
      <div className="skel skel--btn"/>
    </div>
  </div>
);

/* ════════════════════════════════════════
   CURSO CARD — mismo estilo que Inicio
════════════════════════════════════════ */
const CursoCard = ({ c }) => {
  const tipo    = c.seccion === 'en_vivo' || c.seccion === 'proximos' ? 'vivo' : detectTipo(c);
  const cat     = detectCategoria(c);
  const catCls  = getCatClass(cat);
  const alumnos = c.total_estudiantes || 0;
  const desc    = c.descripcion_custom || c.summary_text || c.summary?.replace(/<[^>]+>/g,'') || '';
  const precio  = parseFloat(c.precio_web || 0);

  const { agregarItem, estaEnCarrito } = useCart();
  const { estaLogueado } = useAuthUser();
  const navigate = useNavigate();
  const enCarrito = estaEnCarrito('curso-' + c.id);

  /* Badge acceso */
  const acceso = (c.etiqueta && c.etiqueta.toUpperCase().includes('ACCESO'))
    ? c.etiqueta
    : c.seccion === 'gratuito'
    ? 'ACCESO GRATUITO'
    : 'ACCESO POR 6 MESES';

  /* Tipo label */
  const tipoLabel = c.seccion === 'en_vivo' || c.seccion === 'proximos'
    ? 'PRÓXIMO INICIO'
    : c.seccion === 'gratuito'
    ? 'DISPONIBLE – GRATIS'
    : 'DISPONIBLE – CLASE GRABADA';

  /* Badge negro superior */
  const tipoBadge = c.seccion === 'en_vivo'
    ? 'CURSO EN VIVO'
    : c.seccion === 'proximos'
    ? 'PRÓXIMO CURSO'
    : c.seccion === 'asincrono'
    ? 'CURSO ASINCRÓNICO'
    : c.seccion === 'gratuito'
    ? 'CURSO GRATUITO'
    : 'CURSO FORMATIVO';

  const tipoBadge2 = cat.toUpperCase();

  return (
    <article className="curso-card">

      {/* THUMB */}
      <div
        className={`curso-card__thumb curso-card__thumb--${catCls}`}
        style={(c.imagen_custom || c.imagen_url)
          ? {backgroundImage:`url(${c.imagen_custom || c.imagen_url})`,backgroundSize:'cover',backgroundPosition:'center'}
          : {}}
      >
        {/* Badge negro superior izquierda */}
        <div className="curso-card__tipo-badge">
          <span className="curso-card__tipo-badge-main">{tipoBadge}</span>
          <span className="curso-card__tipo-badge-sub">{tipoBadge2}</span>
        </div>

        {/* Barra acceso inferior */}
        <div className="curso-card__acceso">{acceso}</div>
      </div>

      {/* BODY */}
      <div className="curso-card__body">
        <span className="curso-card__tipo-label">{tipoLabel}</span>
        <h3 className="curso-card__titulo" style={{
          fontWeight: c.titulo_negrita ? 700 : 300,
          textTransform: c.titulo_minusculas ? 'none' : 'uppercase',
        }}>
          {c.titulo_custom || c.fullname}
        </h3>
       {/* {c.shortname && c.seccion !== 'gratuito' && (
          <p className="curso-card__codigo">{c.shortname}</p>
        )}*/}
        {desc && (
          <p className="curso-card__desc">{desc.length>90?desc.slice(0,90)+'…':desc}</p>
        )}
        <div className="curso-card__meta">
          {alumnos > 0 && <span><IconUsers/>{alumnos} alumnos</span>}
          {c.fecha_inicio && <span><IconCalendar/>{c.fecha_inicio}</span>}
        </div>
      </div>

      {/* FOOTER */}
      <div className="curso-card__footer">
      <strong className="curso-card__precio">
          {precio > 0 ? `S/. ${parseInt(precio)}` : (c.seccion === 'en_vivo' || c.seccion === 'proximos' ? '' : 'Gratis')}
          {c.precio_anterior && (
            <s style={{fontSize:'.72rem',color:'#9ca3af',marginLeft:'.4rem',fontWeight:400}}>
              S/. {parseFloat(c.precio_anterior).toFixed(0)}
            </s>
          )}
        </strong>
        <div style={{display:'flex',gap:'.4rem',alignItems:'center'}}>
          {precio > 0 && (
            enCarrito ? (
              <button className="curso-card__btn-carrito curso-card__btn-carrito--ok"
                onClick={() => navigate('/carrito')}>
                <IconBag/> Ver carrito
              </button>
            ) : (
              <button className="curso-card__btn-carrito"
                onClick={() => {
                  if (!estaLogueado) { navigate('/login?redirect=/formaciones'); return; }
                  agregarItem({
                    id:      'curso-' + c.id,
                    titulo:  c.fullname,
                    precio,
                    tipo:    'curso',
                    color:   'verde',
                    imagen:  c.imagen_url || null,
                    digital: true,
                  });
                }}>
                <IconCartPlus/> + Carrito
              </button>
            )
          )}
          <Link to={`/formaciones/${c.id}`} className="curso-card__btn-ver">
            {tipo==='vivo' ? 'Reservar' : 'Ver curso'} →
          </Link>
        </div>
      </div>
    </article>
  );
};

/* ════════════════════════════════════════
   PAGINADOR
════════════════════════════════════════ */
const Paginador = ({ pagina, total, inicio, porPag, totalItems, onChange }) => {
  if (total <= 1) return null;
  const pages = [];
  for (let i = Math.max(1, pagina-2); i <= Math.min(total, pagina+2); i++) pages.push(i);
  return (
    <div className="cursos-pag">
      <p className="cursos-pag__info">
        Mostrando {inicio+1}–{Math.min(inicio+porPag, totalItems)} de {totalItems}
      </p>
      <div className="cursos-pag__controles">
        <button className="cursos-pag__btn" onClick={()=>onChange(Math.max(1,pagina-1))} disabled={pagina===1}><IconChevLeft/></button>
        {pages[0]>1 && <>
          <button className="cursos-pag__num" onClick={()=>onChange(1)}>1</button>
          {pages[0]>2 && <span className="cursos-pag__dots">…</span>}
        </>}
        {pages.map(p=>(
          <button key={p} className={`cursos-pag__num ${p===pagina?'cursos-pag__num--active':''}`} onClick={()=>onChange(p)}>{p}</button>
        ))}
        {pages.at(-1)<total && <>
          {pages.at(-1)<total-1 && <span className="cursos-pag__dots">…</span>}
          <button className="cursos-pag__num" onClick={()=>onChange(total)}>{total}</button>
        </>}
        <button className="cursos-pag__btn" onClick={()=>onChange(Math.min(total,pagina+1))} disabled={pagina===total}><IconChevRight/></button>
      </div>
    </div>
  );
};

/* ════════════════════════════════════════
   COMPONENTE PRINCIPAL
════════════════════════════════════════ */
export default function Formaciones() {
  const { estaLogueado, usuario } = useAuthUser();
  const { totalItems, ultimoAgregado, limpiarUltimoAgregado } = useCart();
  const navigate = useNavigate();

  const [cursos,        setCursos]        = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [error,         setError]         = useState(null);
  const [formGratis,    setFormGratis]    = useState([]);
  const [loadingGratis, setLoadingGratis] = useState(true);

  const [pagGrabado,    setPagGrabado]    = useState(1);
  const [porPagGrabado, setPorPagGrabado] = useState(6);

  useEffect(() => {
    fetch('https://centrocomunicar.com/api-comunicar/endpoints/formaciones_gratis.php?action=list&activo=1')
      .then(r => r.json())
      .then(j => { if (j.success) setFormGratis(j.data || []); })
      .catch(() => {})
      .finally(() => setLoadingGratis(false));
  }, []);

  const fetchCursos = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const res  = await fetch(`${API_BASE}?action=list&visible=1`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      if (!json.success) throw new Error(json.message || 'Error');
      setCursos(json.data || []);
    } catch (err) {
      setError(err.message); setCursos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchCursos(); }, [fetchCursos]);

  useEffect(() => {
    const io = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      }),
      { threshold: 0.08 }
    );
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
    return () => io.disconnect();
  }, [loading, loadingGratis, pagGrabado]);

  const cursosVivo      = cursos.filter(c => c.seccion === 'en_vivo' || ((!c.seccion || c.seccion === 'normal') && detectTipo(c) === 'vivo'));
  const cursosGrabado   = cursos.filter(c => c.seccion === 'normal'  || (!c.seccion && detectTipo(c) === 'grabado'));
  const cursosProximos  = cursos.filter(c => c.seccion === 'proximos');
  const cursosAsincrono = cursos.filter(c => c.seccion === 'asincrono');
  const cursosGratuitos = cursos.filter(c => c.seccion === 'gratuito');

  const totalPagGrabado  = Math.max(1, Math.ceil(cursosGrabado.length / porPagGrabado));
  const pGrabadoSeg      = Math.min(pagGrabado, totalPagGrabado);
  const inicioGrabado    = (pGrabadoSeg - 1) * porPagGrabado;
  const cursosGrabadoPag = cursosGrabado.slice(inicioGrabado, inicioGrabado + porPagGrabado);

  const ahora   = Math.floor(Date.now() / 1000);
  const proximos = [
    ...cursosProximos,
    ...cursosVivo.filter(c => (c.startdate_ts || c.timecreated) > ahora),
  ]
    .sort((a,b) => (a.startdate_ts||a.timecreated||0) - (b.startdate_ts||b.timecreated||0))
    .slice(0, 5);

  const handlePorPag = (n) => { setPorPagGrabado(n); setPagGrabado(1); };

  return (
    <div className="form-page">

      {/* NAV */}
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
        <div className="nav__links">
          <Link to="/">Inicio</Link>
          <Link to="/formaciones" style={{color:'var(--verde-dk)',fontWeight:700}}>Cursos</Link>
          <Link to="/recursos">Materiales</Link>
          <Link to="/comunidad">Comunidad</Link>
          <Link to="/articulos">Blog</Link>


          <a href="https://centrocomunicar.com/virtual/login/index.php"
            target="_blank" rel="noopener noreferrer"
            className="nav__aula-btn">
            <span className="aula-icon">📖</span>
            Aula Virtual
          </a>
          
        </div>
      
        <div className="nav__actions">
          <Link to="/carrito"
            style={{position:'relative',display:'flex',alignItems:'center',padding:'.4rem .7rem',borderRadius:100,border:'1.5px solid rgba(130,216,179,.3)',color:'var(--gris,#5a6a63)',transition:'all .2s'}}
            title="Ver carrito">
            <IconCart/>
            {totalItems > 0 && (
              <span style={{position:'absolute',top:-6,right:-6,background:'#82D8B3',color:'#111614',borderRadius:'50%',width:18,height:18,fontSize:'.62rem',fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>
                {totalItems > 9 ? '9+' : totalItems}
              </span>
            )}
          </Link>
          {estaLogueado
            ? <Link to="/mi-cuenta" className="nav__mi-cuenta">● {usuario.nombre}</Link>
            : <Link to="/login" className="nav__login">Iniciar sesión</Link>
          }
        </div>

      </nav>

      {/* ══ CURSOS GRATUITOS ══ */}
      <section className="cursos-bloque cursos-bloque--hero" id="gratuitos">
        <div className="cursos-bloque__inner">
          <div className="cursos-bloque__head cursos-bloque__head--hero">
            <div>
              <p className="section-label">Sin costo</p>
              <h2 className="cursos-bloque__titulo">Cursos <em>gratuitos</em></h2>
              <p className="cursos-bloque__sub">
                Accede a contenido formativo sin costo. Solo regístrate con tu nombre y correo.
              </p>
            </div>
            
          </div>

          {loadingGratis && (
            <div className="cursos-grid">{[...Array(3)].map((_,i) => <SkeletonCard key={i}/>)}</div>
          )}
          {!loadingGratis && !loading && formGratis.length === 0 && cursosGratuitos.length === 0 && (
            <div className="cursos-empty"><p>No hay cursos gratuitos disponibles por ahora.</p></div>
          )}

          {/* Cursos Moodle gratuitos */}
          {!loading && cursosGratuitos.length > 0 && (
            <div style={{marginBottom:'1.5rem'}}>
              <p style={{fontSize:'.78rem',fontWeight:700,color:'#14736C',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:'1rem'}}>
                🎓 Desde el Aula Virtual
              </p>
              <div className="cursos-grid">
                {cursosGratuitos.map(c => <CursoCard key={c.id} c={c}/>)}
              </div>
            </div>
          )}

          {/* Formaciones gratis manuales */}
          {!loadingGratis && formGratis.length > 0 && (
            <div className="cursos-grid">
              {formGratis.map((f, i) => {
                const colKey = FG_CAT_COLORS[f.categoria] || 'verde';
                const bg     = FG_COLOR_MAP[colKey];
                return (
                  <Link to={`/formaciones-gratis/${f.slug}`} className="curso-card reveal" key={f.id} style={{'--delay':`${i*0.08}s`}}>
                    <div className="curso-card__thumb" style={{background:bg,position:'relative',overflow:'hidden'}}>
                      <div className="curso-card__tipo-badge">
                        <span className="curso-card__tipo-badge-main">CURSO GRATUITO</span>
                        <span className="curso-card__tipo-badge-sub">{(f.categoria||'').toUpperCase()}</span>
                      </div>
                      <div className="curso-card__acceso">ACCESO GRATUITO</div>
                      {f.total_inscritos > 0 && (
                        <span style={{position:'absolute',bottom:'3rem',right:'.8rem',fontSize:'.68rem',fontWeight:700,color:'rgba(0,0,0,.5)',background:'rgba(255,255,255,.55)',padding:'.2rem .6rem',borderRadius:100,display:'flex',alignItems:'center',gap:'.25rem',zIndex:3}}>
                          <IconUsers/>{f.total_inscritos}
                        </span>
                      )}
                    </div>
                    <div className="curso-card__body">
                      <span className="curso-card__tipo-label">DISPONIBLE – GRATIS</span>
                      <h3 className="curso-card__titulo">{f.titulo}</h3>
                      {f.descripcion && <p className="curso-card__desc">{f.descripcion}</p>}
                      <div className="curso-card__meta">
                        {f.duracion  && <span>⏱ {f.duracion}</span>}
                        {f.instructor && <span>👤 {f.instructor}</span>}
                      </div>
                    </div>
                    <div className="curso-card__footer">
                      <strong className="curso-card__precio" style={{color:'var(--verde-dk)'}}>Gratis</strong>
                      <span className="curso-card__btn-ver">Acceder →</span>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* ══ CURSOS EN VIVO ══ */}
      <section className="cursos-bloque cursos-bloque--oscuro reveal">
        <div className="cursos-bloque__inner">
          <div className="cursos-bloque__head">
            <div>
            <p className="section-label" style={{color:'#8BCAAF'}}>Formación en tiempo real</p>
              <h2 className="cursos-bloque__titulo">Cursos <em style={{color:'#8BCAAF'}}>en vivo</em></h2>
<p className="cursos-bloque__sub" style={{color:'rgba(255,255,255,.6)'}}>
  Accede a contenido formativo sin costo. Solo regístrate con tu nombre y correo.
</p>            </div>
           
          </div>
          {loading && <div className="cursos-grid">{[...Array(3)].map((_,i) => <SkeletonCard key={i}/>)}</div>}
          {!loading && cursosVivo.length === 0 && (
            <div className="cursos-empty cursos-empty--dark"><p>No hay cursos en vivo programados por ahora.</p></div>
          )}
          {!loading && cursosVivo.length > 0 && (
            <div className="cursos-grid">
              {cursosVivo.map(c => <CursoCard key={c.id} c={c}/>)}
            </div>
          )}
        </div>
      </section>

      {/* ══ CURSOS GRABADOS ══ */}
      <section className="cursos-bloque cursos-bloque--blanco reveal">

        <div className="cursos-bloque__inner">
          <div className="cursos-bloque__head">
            <div>
              <p className="section-label">A tu ritmo</p>
              <h2 className="cursos-bloque__titulo">
                Cursos <em style={{color:'#8BCAAF'}}>grabados</em>
              </h2>
<p className="cursos-bloque__sub">
  Accede a contenido formativo sin costo. Solo regístrate con tu nombre y correo.
</p>
            </div>
           
            <div className="cursos-bloque__controles">
              <div className="cursos-ppp">
                <span>Ver:</span>
                {[6, 12, 24].map(n => (
                  <button key={n}
                    className={`cursos-ppp__btn ${porPagGrabado === n ? 'cursos-ppp__btn--active' : ''}`}
                    onClick={() => handlePorPag(n)}>
                    {n}
                  </button>
                ))}
              </div>
             
            </div>

          </div>
          {loading && <div className="cursos-grid">{[...Array(porPagGrabado)].map((_,i) => <SkeletonCard key={i}/>)}</div>}
          {error && !loading && (
            <div className="cursos-empty cursos-empty--error">
              <p>⚠️ {error}</p>
              <button className="cursos-retry" onClick={fetchCursos}><IconRefresh/> Reintentar</button>
            </div>
          )}
          {!loading && !error && cursosGrabado.length === 0 && (
            <div className="cursos-empty"><p>No hay cursos grabados disponibles.</p></div>
          )}
          {!loading && !error && cursosGrabadoPag.length > 0 && (
            <>
              <div className="cursos-grid">
                {cursosGrabadoPag.map(c => <CursoCard key={c.id} c={c}/>)}
              </div>
              <Paginador
                pagina={pGrabadoSeg} total={totalPagGrabado}
                inicio={inicioGrabado} porPag={porPagGrabado}
                totalItems={cursosGrabado.length} onChange={setPagGrabado}
              />
            </>
          )}
        </div>
      </section>

      {/* ══ ASINCRÓNICOS ══ */}
      {!loading && cursosAsincrono.length > 0 && (
     <section className="cursos-bloque cursos-bloque--oscuro2 reveal">

          <div className="cursos-bloque__inner">
            <div className="cursos-bloque__head">
              <div>
              <p className="section-label" style={{color:'#8BCAAF'}}>A tu ritmo — sin fecha límite</p>
              <h2 className="cursos-bloque__titulo">Cursos <em style={{color:'#8BCAAF'}}>asincrónicos</em></h2>
<p className="cursos-bloque__sub">
  Accede a contenido formativo sin costo. Solo regístrate con tu nombre y correo.
</p>
              </div>
            
            </div>
            <div className="cursos-grid">
              {cursosAsincrono.map(c => <CursoCard key={c.id} c={c}/>)}
            </div>
          </div>
        </section>
      )}

      {/* ══ PRÓXIMOS CURSOS ══ */}
      <section className="proximos-section reveal">
        <div className="proximos-section__inner">
          <div className="proximos-section__head">
            <p className="section-label">Agenda</p>
            <h2>Próximos <em>cursos</em></h2>
            <p className="proximos-section__sub">Reserva tu lugar antes de que se llenen.</p>
          </div>
          {loading && (
            <div className="cal-loading"><div className="cal-loading__spinner"/><p>Cargando…</p></div>
          )}
          {!loading && proximos.length === 0 && (
            <div className="cursos-empty"><p>No hay próximos cursos programados. Vuelve pronto.</p></div>
          )}
          {!loading && proximos.length > 0 && (
            <div className="proximos-lista">
              {proximos.map((c, i) => {
                const fecha = new Date((c.startdate_ts || c.timecreated) * 1000);
                const dia   = String(fecha.getDate()).padStart(2,'0');
                const mes   = fecha.toLocaleString('es-PE',{month:'short'}).toUpperCase().replace('.','');
                const anio  = fecha.getFullYear();
                return (
                  <div className="proximo-item reveal" key={c.id} style={{'--delay':`${i*0.1}s`}}>
                    <div className="proximo-item__fecha">
                      <strong>{dia}</strong>
                      <span>{mes}</span>
                      <span className="proximo-item__anio">{anio}</span>
                    </div>
                    <div className="proximo-item__info">
                      <span className="proximo-item__tipo"><IconLive/> Curso en vivo</span>
                      <h4>{c.fullname}</h4>
                      <p>{c.shortname || `Inicia el ${c.fecha_inicio}`}</p>
                    </div>
                    <div className="proximo-item__meta">
                      <span><IconUsers/>{c.total_estudiantes||0} inscritos</span>
                    </div>
                    <Link to={`/formaciones/${c.id}`} className="proximo-item__btn">
                      Reservar plaza <IconArrow/>
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* ══ AULA VIRTUAL ══ */}
      <section className="aula-section reveal">
        <div className="aula-section__inner">
          <div className="aula-section__content">
          <p className="section-label" style={{color:'#8BCAAF'}}>¿Ya tienes un curso?</p>
          <h2>Accede al <em style={{color:'#8BCAAF'}}>Aula Virtual</em></h2>

            <p>Ingresa a tus cursos, materiales y clases grabadas desde un solo lugar. Disponible las 24 horas.</p>
            <div className="aula-section__beneficios">
              <div className="aula-ben-item"><IconBook/><span>Acceso ilimitado a tus cursos</span></div>
              <div className="aula-ben-item"><IconMonitor/><span>Clases grabadas para repasar</span></div>
              <div className="aula-ben-item"><IconCertificate/><span>Descarga tus certificados</span></div>
            </div>
            <a href={AULA_URL} target="_blank" rel="noopener noreferrer" className="aula-section__btn"
              style={{background:'transparent',color:'#8BCAAF',border:'1.5px solid #8BCAAF'}}>
              <IconMonitor/> Ingresar al Aula Virtual <IconExternalLink/>
            </a>
            <p className="aula-section__nota">Se abrirá en una nueva pestaña · Plataforma Moodle</p>
          </div>
          <div className="aula-section__mockup">
            <div className="aula-mockup">
              <div className="aula-mockup__bar">
                <span/><span/><span/>
                <span className="aula-mockup__url">centrocomunicar.com/virtual</span>
              </div>
              <div className="aula-mockup__body">
                <div className="aula-mockup__item aula-mockup__item--active">
                  <IconPlay/>
                  <div><p>Mi curso activo</p><span>En progreso</span></div>
                </div>
                <div className="aula-mockup__item">
                  <IconBook/>
                  <div><p>Materiales del curso</p><span>Disponible</span></div>
                </div>
                <div className="aula-mockup__item">
                  <IconCertificate/>
                  <div><p>Certificado</p><span>Al completar</span></div>
                </div>
                <a href={AULA_URL} target="_blank" rel="noopener noreferrer" className="aula-mockup__link"
                  style={{background:'#8BCAAF',color:'#032D29'}}>
                  Ir al Aula <IconExternalLink/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ FOOTER ══ */}
      <footer className="footer">
        <div className="footer__top">
          <div className="footer__brand">
            <p className="footer__brand-desc">
              Cursos especializados y materiales terapéuticos para profesionales
              y familias que trabajan el desarrollo del lenguaje.
            </p>
            <div className="footer__social">
              <a href="https://www.instagram.com/comunicar_terapias" className="footer__social-btn" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>
              </a>
              <a href="https://www.facebook.com/comunicar.terapias" className="footer__social-btn" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </a>
              <a href="https://api.whatsapp.com/send/?phone=51940686868" className="footer__social-btn" aria-label="WhatsApp">
                <svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </a>
            </div>
          </div>
          <div className="footer__cols">
            <div className="footer__col">
              <h4>Cursos</h4>
              <Link to="/formaciones#gratuitos">Cursos gratuitos</Link>
              <Link to="/formaciones">Cursos grabados</Link>
              <Link to="/formaciones">Cursos en vivo</Link>
              <a href={AULA_URL} target="_blank" rel="noopener noreferrer">Aula virtual ↗</a>
            </div>
            <div className="footer__col">
              <h4>Materiales</h4>
              <Link to="/recursos">Imprimibles</Link>
              <Link to="/recursos">Cuadernillos</Link>
              <Link to="/recursos">Juegos terapéuticos</Link>
            </div>
            <div className="footer__col">
              <h4>Comunidad</h4>
              <Link to="/comunidad">Redes sociales</Link>
              <Link to="/comunidad">Boletín mensual</Link>
              <Link to="/comunidad">Programa de puntos</Link>
            </div>
          </div>
          <div className="footer__newsletter">
            <h4>Recibe novedades</h4>
            <p>Nuevos cursos y materiales gratuitos en tu correo.</p>
            <div className="footer__form">
              <input type="email" placeholder="tu@correo.com" className="footer__input"/>
              <button className="footer__submit"><IconArrow/></button>
            </div>
            <div className="footer__legal-links">
              <Link to="/atencion-cliente">Atención al cliente</Link>
              <Link to="/legal">Legal</Link>
              <Link to="/libro-reclamaciones">Libro de reclamaciones</Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <p>© 2026 Comunicar – Desarrollo y Lenguaje. Todos los derechos reservados.</p>
          <p style={{fontSize:'.75rem',color:'rgba(255,255,255,.3)',marginTop:'.3rem'}}>
            Dirección: Teniente Carlos Moore 1386, Cercado de Lima
          </p>
          <div className="footer__legal">
            <Link to="/legal">Privacidad</Link>
            <Link to="/legal">Términos y condiciones</Link>
            <Link to="/politica-devoluciones">Política de devoluciones</Link>
          </div>
        </div>
      </footer>

      {/* Widget redes sociales flotante */}
      <div style={{position:'fixed',right:0,top:'50%',transform:'translateY(-50%)',zIndex:100,display:'flex',flexDirection:'column',gap:2}}>
        {[
          {href:'https://www.facebook.com/comunicar.terapias',bg:'#1877f2',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>},
          {href:'https://www.instagram.com/comunicar_terapias',bg:'#e1306c',icon:<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>},
          {href:'https://api.whatsapp.com/send/?phone=51940686868',bg:'#25d366',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>},
          {href:'https://www.youtube.com/@CentroComunicar',bg:'#ff0000',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>},
        ].map(({href,bg,icon}) => (
          <a key={href} href={href} target="_blank" rel="noopener noreferrer"
            style={{width:40,height:40,background:bg,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',transition:'opacity .2s'}}
            onMouseEnter={e=>e.currentTarget.style.opacity='.8'}
            onMouseLeave={e=>e.currentTarget.style.opacity='1'}>
            {icon}
          </a>
        ))}
      </div>

    </div>
  );
}